import React, { useState, useRef, useEffect } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Modal } from "react-bootstrap";
import swal from "sweetalert";
import videoLoader from "../../../assets/images/small-loader.gif";
import deleteBtn from "../../../assets/svg/deleteBtn.svg";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function BasicModal(props) {
  //   const [open, setOpen] = React.useState(false);
  const { open, setOpen, videoUrl, videoList ,canDelete,sessionTitle } = props;
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    // setToggleMsg(true);
    // setDeleteList([]);
    // setIncomingList([]);
  };
  const [toggleMsg, setToggleMsg] = useState(false);
  useEffect(() => {
    if (open) {
      setToggleMsg(true);
    }
  }, [open]);
  const [incomingList, setIncomingList] = useState([]);
  const [currentVid, setCurrentVid] = useState({ name: "", url: "" });
  const [deleteList, setDeleteList] = useState([]);
  useEffect(() => {
    if (
      videoList !== undefined &&
      videoList !== null &&
      videoList !== "" &&
      videoList?.length > 1
    ) {
      let testArr = [];
      videoList.forEach((element) => {
        testArr.push(element);
      });
      setIncomingList(testArr);
      setCurrentVid({ name: "Recording 1", url: testArr[0], index: 0 });
    } else {
      setIncomingList([]);
    }
  }, [videoList]);
  function changeSource(url) {
    setToggleMsg(true);
    var video = document.getElementById("video");
    video.src = url;
    video.play();
  }
  const handleDelete = () => {
   
    if (deleteList?.length == 0 && incomingList?.length > 1) {
      swal({
        title: "Warning",
        text: `Please select the recording to be deleted.`,
        icon: "info",
      });
    } else {
      swal("Are you sure?", `Do you want to delete ${deleteList?.length > 1  ?  "these recordings" : "this recording"} ?`, {
        icon: "warning",
        buttons: {
          delete: {
            text: "OK",
          },
          decline: {
            text: "CANCEL",
          },
        },
      })
        .then((value) => {
          if (value === "delete") {
            swal("Success", "Recording deleted successfully.", "success", {
              closeOnClickOutside: false,
            }).then(function () {
              window.close();
            });
            // deleteapiCall();
          } else {
            swal("Delete operation cancelled.");
          }
        })

        .catch((err) => {});
    }
  };
  const testPresence=(url)=>{
    let xyz="asdsadasd"
  //  let test= deleteList.some( itemList =>
  //    itemList['url'] === url
  //   )
  //   console.log("url to check tested",test)
  //   return test
  var doesExist = deleteList.some(function(ele) {
    return ele.url === url;
});
   return doesExist
  }
  return (
    <Modal
      size="lg"
      show={props.open}
      onHide={() => props.setOpen(false)}
      aria-labelledby="example-modal-sizes-title-lg"
      className={
        incomingList?.length > 0 ? "sessionnewmodal2233" : "sessionnewmodal2232"
      }
    >
      <Modal.Header className="d-flex">
        <Modal.Title className="modalHeading mysessioncalendarhead">
          SESSION RECORDING
        </Modal.Title>
        <div className="newuserTooltip">
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handleClose}
          />
          <span
            className="tooltiptext  close-window"
            style={{ left: "-115px", top: "2px", width: "118px" }}
          >
            Close Window
          </span>
        </div>
      </Modal.Header>

      <Modal.Body style={{ height: "470px" }}>
        <div style={{ display: "flex" }}>
          <div className="modalHeadingTitle" style={incomingList?.length > 1 ? {width:"80%"} : {width:"100%"}}>{sessionTitle !== undefined && sessionTitle !== "" && sessionTitle !== null && `${sessionTitle} ${incomingList?.length > 1 ? ", " :""}`} {currentVid?.name}</div>
          {
            canDelete &&
            <div style={{display:"flex"}}>
              {/* <div style={{display:"flex"}}>
              <input
                        value="test"
                        type="checkbox"
                        onChange={(e) => {
                          console.log("handleChange", e.target.checked);
                          let activeState = e.target.checked;
                          let arrList = [];
                          if(activeState){
                            incomingList.forEach((item,index) => {
                              arrList.push({ index: index, url: item });
                            });
                            setDeleteList(arrList);
                          }
                          else{
                            setDeleteList([]);
                          }
                         
                        }}
                      />
                </div>
                <div className="selectAllText">Select All</div> */}
            {/* <div
            className="newuserTooltip"
            style={{
              marginLeft: "1rem",
              marginRight: "1rem",
              cursor: "pointer",
              marginTop: "1.15rem",
            }}
            onClick={() => handleDelete()}
          >
            <img src={deleteBtn} width={24} height={24} />
            <span
              className="tooltiptext tooltip-bottom"
              style={{
                width: "150px",
                position: "absolute",
                left: "5px",
                top: "35px",
              }}
            >
              Delete the recording
            </span>
          </div> */}
        </div>
}</div>
        {incomingList?.length > 0 ? (
          <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
            <div style={{ width: "82%" }}>
              <>
                {toggleMsg && (
                  <div className="overlayText">
                    <p className="topText">
                      Please wait a few moments, video is loading ...
                    </p>
                  </div>
                )}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                  className="statusiconsmodal newcompletediconsabove"
                >
                  <video
                    id={"video"}
                    width="96%"
                    height="100%"
                    controls
                    preload="auto"
                    autoplay="autoplay"
                    onLoadedData={() => {
                      setToggleMsg(false);
                    }}
                    onEnded={() => {
                      if (currentVid?.index + 1 < incomingList?.length) {
                        setCurrentVid({
                          name: `Recording ${currentVid?.index + 2}`,
                          url: incomingList[currentVid?.index + 1],
                          index: currentVid?.index + 1,
                        });
                        changeSource(incomingList[currentVid?.index + 1]);
                      } else {
                        setCurrentVid({
                          name: "Recording 1",
                          url: incomingList[0],
                          index: 0,
                        });
                        changeSource(incomingList[0]);
                      }
                    }}
                  >
                    <source src={currentVid?.url} type="video/mp4" />
                  </video>
                </div>
              </>
            </div>
            <div
              className={
                incomingList?.length > 8 ? "modalListFlow" : "modalListFlow2"
              }
            >
              {incomingList.map((item, index) => {
                return (
                  <div style={{ display: "flex", alignItems: "end" }}>
                    {/* <div>
                      <input
                        value="test"
                        type="checkbox"
                        onChange={(e) => {
                          console.log("handleChange", e.target.checked);
                          let activeState = e.target.checked;
                          let arrList = deleteList;
                          if (activeState) {
                            arrList.push({ index: index, url: item });
                            setDeleteList(arrList);
                          } else {
                            arrList = arrList.filter(
                              (deleteItem) => deleteItem?.url !== item
                            );
                            setDeleteList(arrList);
                          }
                        }}
                      />
                    </div> */}
                    <div
                      className={
                        index == currentVid?.index
                          ? "mt-3 color-green purpleBackground newuserTooltip"
                          : "mt-3 color-green newuserTooltip"
                      }
                      style={{
                        width: "fit-content",
                        cursor: "pointer",
                        marginLeft: "0.45rem",
                        whiteSpace: "nowrap",
                      }}
                      onClick={() => {
                        setCurrentVid({
                          name: `Recording ${index + 1}`,
                          url: item,
                          index: index,
                        });
                        changeSource(item);
                      }}
                    >
                      {"Recording "}
                      {""}
                      {index + 1}
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{
                          width: "250px",
                          position: "absolute",
                          left: "5px",
                          top: "35px",
                        }}
                      >
                        Click to view Recording
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <>
            {toggleMsg && (
              <div className="overlayText">
                <p className="topText">
                  Please wait a few moments, video is loading ...
                </p>
              </div>
            )}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
              className="statusiconsmodal newcompletediconsabove"
            >
              <video
                style={{ margin: "18px" }}
                width="96%"
                height="100%"
                controls
                preload="auto"
                autoplay="autoplay"
                onLoadedData={() => {
                  setToggleMsg(false);
                }}
              >
                <source src={videoUrl && videoUrl} type="video/mp4" />
              </video>
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}